/* Reef Lagoon — Closing zone (reef floor + email capture).
 * Reveals the capture panel once on scroll-in (fade + rise), transform/opacity only,
 * gated behind prefers-reduced-motion. The background reef photo is never animated.
 * Idempotent; re-inits on shopify:section:load. */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.rfzInit === '1') return;
    root.dataset.rfzInit = '1';

    if (REDUCE || !('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }

    root.classList.add('rfz--observe');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);
  }

  function all() {
    var els = document.querySelectorAll('[data-rfz]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-rfz]') : null;
    if (el) init(el); else all();
  });
})();
